// Site Configuration - FGS / MaProtection-IA.fr
// Numéro 1 en France Ajax Systems

const defaultConfig = {
  company: {
    name: "FGS",
    brandName: "MaProtection-IA",
    domain: "maprotection-ia.fr",
    legalName: "VAUDIN Gaël - FGS",
    siret: "",
    slogan: "Numéro 1 en France Ajax Systems",
    description: "FGS / MAPROTECTION-IA / Numéro 1 en France Ajax Systems. Installation alarme et vidéosurveillance professionnelle à Montpellier et Sud de la France.",
  },
  contact: {
    phone: "07 45 04 09 29",
    phoneFormatted: "+33745040929",
    whatsapp: "+33745040929",
    email: "contact@maprotection-ia.fr",
  },
  address: {
    street: "6 Bis Boulevard Berthelot",
    complement: "Bureau 3",
    postalCode: "34000",
    city: "MONTPELLIER",
    country: "France",
    full: "6 Bis Boulevard Berthelot - Bureau 3, 34000 MONTPELLIER",
    mapsUrl: "https://maps.google.com/?q=6+Bis+Boulevard+Berthelot+34000+Montpellier",
    mapsEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2888.8!2d3.8767!3d43.6108!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12b6af0725dd9db1%3A0xad8756742894e802!2s6%20Boulevard%20Berthelot%2C%2034000%20Montpellier!5e0!3m2!1sfr!2sfr!4v1705000000000!5m2!1sfr!2sfr",
  },
  social: {
    facebook: "https://facebook.com/maprotectionia",
    linkedin: "https://linkedin.com/company/fgssecurity",
    instagram: "https://instagram.com/maprotectionia",
  },
  seo: {
    title: "FGS | MaProtection-IA.fr - N°1 Ajax Systems France",
    description: "FGS / MAPROTECTION-IA / Numéro 1 en France Ajax Systems. Installation alarme et vidéosurveillance professionnelle à Montpellier et Sud de la France. Garantie 4 ans, devis gratuit.",
    keywords: "maprotection-ia, FGS, alarme ajax systems, installation alarme montpellier, vidéosurveillance hérault",
    ogImage: "https://maprotection-ia.fr/og-image.jpg",
    canonical: "https://maprotection-ia.fr",
  },
};

export default defaultConfig;
